// extracted by mini-css-extract-plugin
module.exports = {"box":"CloseButtonFields_box__3MAZW","closeButtonToggleWrapper":"CloseButtonFields_closeButtonToggleWrapper__3eDAl","colors":"CloseButtonFields_colors__24h1x"};